import { render } from "./ProyectoContactosPanel.vue?vue&type=template&id=5fae9289&scoped=true"
import script from "./ProyectoContactosPanel.vue?vue&type=script&lang=js"
export * from "./ProyectoContactosPanel.vue?vue&type=script&lang=js"

import "./ProyectoContactosPanel.vue?vue&type=style&index=0&id=5fae9289&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fae9289"]])

export default __exports__